import React from 'react'
import * as R from 'ramda'
import { LoaderRow } from 'components/shared/Table/common/LoaderRow/LoaderRow'
import { Pagination } from 'components/shared/Table/common/Pagination/Pagination'
import { useUserProjectsTable } from './hooks'
import styles from './UserProjectsTable.module.scss'
import { CardTable } from 'components/shared/CardTable/CardTable'
import { CardTableHeader } from 'components/shared/CardTable/CardTableHeader'
import { CardTableHeaderCell } from 'components/shared/CardTable/CardTableHeaderCell'
import { CardTableRow } from 'components/shared/CardTable/CardTableRow'
import { CardTableCell } from 'components/shared/CardTable/CardTableCell'
import { NoJobs } from './NoJobs'
import { t } from 'ttag'
import { capitalizeFirstLetter } from 'utils/helpers'

const mapSortingPropToQueryParam = {
  name: 'name',
}

export const UserProjectsTable = ({ search, selectedUser, department, id }) => {
  const {
    state: {
      pagination: { currentPage, pageCount, perPage },
      table: { headers, model, isFetching, isAllProjectsAccess },
    },
    handlers: {
      pagination: { handlePage, handlePageSize },
      handleSetAccess,
      toggleSelectAll,
    },
  } = useUserProjectsTable({
    mapSortingPropToQueryParam,
    selectedUser,
    department,
    search,
    id,
  })

  if (!isFetching && model.rows?.length === 0) {
    return <NoJobs />
  }

  return (
    <CardTable>
      {!isFetching && (
        <CardTableHeader
          withCheckbox
          checkboxLabel={t`Access all jobs`}
          toggleSelectAll={toggleSelectAll}
          selected={isAllProjectsAccess}
        >
          {R.map(({ columnDef }) => {
            const { header, width } = columnDef

            return (
              <CardTableHeaderCell key={header} id={header} width={width}>
                {capitalizeFirstLetter(header)}
              </CardTableHeaderCell>
            )
          }, headers)}
        </CardTableHeader>
      )}
      {isFetching && <LoaderRow className={styles.loader} />}
      {R.map(({ id, original }) => {
        const { name, members_with_access } = original

        const userId = selectedUser?.id
        const selected = members_with_access
          .map(member => member.id)
          .includes(userId)

        return (
          <CardTableRow
            key={id}
            id={id}
            className={styles.cardTableRow}
            withCheckbox
            selected={selected}
            toggleRowSelection={id =>
              handleSetAccess({ selected, projectId: id })
            }
          >
            <CardTableCell width="100%">{name}</CardTableCell>
          </CardTableRow>
        )
      }, model.rows)}
      {!isFetching && (
        <Pagination
          onSetPage={handlePage}
          onSetPageSize={handlePageSize}
          options={[
            { label: 7, value: 7 },
            { label: 10, value: 10 },
            { label: 15, value: 15 },
          ]}
          {...{ currentPage, pageCount, perPage }}
        />
      )}
    </CardTable>
  )
}
